import React from 'react';
import { TextField, makeStyles } from '@material-ui/core';

const useTextClasses = makeStyles({
    root: {
        width: props => (props.width ? props.width : '100%'),
    },
    underline: {
        '&::before': { borderBottom: '1px solid #d9d9d9' }
    },
    label: {
        fontSize: props => (props.labelFontsize ? props.labelFontsize : 11),
    },
    input: {
        fontSize: props => (props.fontSize ? props.fontSize : '1em'),
    }
});

const TextInput = ({ label, onInput, placeholder, type, width, labelFontsize, fontSize, style = {} }) => {
    const textClasses = useTextClasses({ width, labelFontsize, fontSize });

    return (
        <TextField
            classes={{ root: textClasses.root }}
            placeholder={placeholder}
            InputLabelProps={{ classes: { root: textClasses.label }}}
            InputProps={{ classes: { root: textClasses.input, underline: textClasses.underline }, type: type || 'text' }}
            onChange={onInput}
            size="small" label={label} onInput={onInput}
            style={style}
        />
    );
};

export default TextInput;
